import jquery from 'jquery';
import 'jquery.transit';
import 'jquery-easing';
import 'es6-promise/auto';

window.$ = jquery;
window.jQuery = jquery;

import owd from 'owd/owd';
import 'app/components/img-load';
import 'app/components/form';
import 'app/components/upload';
import 'app/components/slider';
import 'app/components/scroll-top';
import 'app/components/menu-toggle';
import 'app/components/nav-toggle';
import 'app/components/inview';
import 'app/components/select';
import 'app/components/accordion';
import 'app/components/menu';
import 'app/components/inline-dots';
import 'app/components/video';
import 'app/components/youtube';
import 'app/components/header';
import 'app/components/marquee';
import 'app/components/tickets-hero';
import 'app/components/preloader';
import 'app/components/fix-100vh';
import 'app/components/hero-init';
import 'app/components/lineup';
import 'app/components/modal';
import 'app/components/modal-cookies';
import 'app/components/modal-info';
import 'app/components/recaptcha';
import 'app/components/zoom';
import 'app/components/newsletter';
import 'app/components/set-active-tickets';
import 'app/components/set-active-tickets-page';
import 'app/components/menu-home';

import DefaultResolver from 'app/ajax/default-resolver';
import CategoriesResolver from 'app/ajax/categories-resolver';
import LineupResolver from 'app/ajax/lineup-resolver';
import TicketsResolver from 'app/ajax/tickets-resolver';
import SubpageResolver from 'app/ajax/subpage-resolver';

import ResizeX from 'owd/module/resize-x';

import Ajax from 'owd/module/ajax';
// import FullPage from 'owd/module/fullpage';
// import ScrollbarPlaceholder from 'owd/module/scrollbar-placeholder';

const app = new owd.App();

// app.use('scrollbarPlaceholder', ScrollbarPlaceholder);
// app.use('fullpage', FullPage);
app.use('resize-x', ResizeX);
app.use('ajax', Ajax)
    .registerDefaultResolver(DefaultResolver)
    .registerResolver('categories', CategoriesResolver)
    .registerResolver('subpage', SubpageResolver)
    .registerResolver('lineup', LineupResolver)
    .registerResolver('tickets', TicketsResolver);
app.run();
